import { useRef } from 'react'
import { Check } from 'lucide-react'

/* 40 colori ben distribuiti sullo spettro, leggibili su sfondi scuri */
export const PALETTE = [
  // Grigi/neutri
  '#374151','#6b7280','#9ca3af','#94a3b8','#64748b','#475569','#cbd5e1','#e2e8f0',
  // Rossi/arancioni/ambra
  '#991b1b','#dc2626','#ea580c','#c2410c','#d97706','#f59e0b','#ca8a04','#b45309',
  // Verdi/smeraldo/teal
  '#14532d','#15803d','#16a34a','#22c55e','#059669','#10b981','#14b8a6','#0d9488',
  // Ciano/blu
  '#0c4a6e','#0891b2','#0369a1','#1d4ed8','#2563eb','#3b82f6','#06b6d4','#22d3ee',
  // Viola/indaco/rosa/fucsia
  '#3730a3','#4f46e5','#7c3aed','#8b5cf6','#9333ea','#a855f7','#db2777','#ec4899',
]

/**
 * ColorPicker
 * @param {string}   value    — hex corrente
 * @param {function} onChange — (hex: string) => void
 * @param {string}   label    — etichetta opzionale
 */
const ColorPicker = ({ value, onChange, label = 'Colore' }) => {
  const inputRef = useRef(null)

  return (
    <div>
      {label && <label className="block text-sm text-gray-400 mb-2">{label}</label>}

      {/* Palette griglia 8×5 */}
      <div className="grid grid-cols-8 gap-1.5 mb-3">
        {PALETTE.map(c => (
          <button
            key={c}
            type="button"
            title={c}
            onClick={() => onChange(c)}
            className={`w-7 h-7 rounded-lg flex items-center justify-center transition-all hover:scale-110 ${
              value === c ? 'ring-2 ring-white/80 ring-offset-1 ring-offset-gray-900 scale-110' : 'hover:ring-1 hover:ring-white/30 hover:ring-offset-1 hover:ring-offset-gray-900'
            }`}
            style={{ backgroundColor: c }}
          >
            {value === c && <Check size={12} className="text-white drop-shadow" strokeWidth={3} />}
          </button>
        ))}
      </div>

      {/* Selettore colore personalizzato */}
      <div className="flex items-center gap-2.5">
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="flex items-center gap-2 px-3 py-1.5 bg-gray-800 border border-gray-700 rounded-lg text-xs text-gray-400 hover:text-white hover:border-gray-500 transition-colors"
        >
          <span className="w-4 h-4 rounded border border-gray-600 flex-shrink-0" style={{ backgroundColor: value }} />
          <span>Personalizzato…</span>
        </button>
        <span className="text-xs text-gray-600 font-mono tracking-wide">{value?.toUpperCase()}</span>
        <input
          ref={inputRef}
          type="color"
          value={value || '#7c3aed'}
          onChange={e => onChange(e.target.value)}
          className="sr-only"
        />
      </div>
    </div>
  )
}

export default ColorPicker
